import { Epic } from 'redux-observable';
import { filter, map, mergeMap } from 'rxjs/operators';
import { boothEditActions } from 'admin-data/booth/BoothEdit/redux/boothEditActions';
import boothEditSelectors from 'admin-data/booth/BoothEdit/redux/boothEditSelectors';
import { mapToSimpleMergeBoothAction, boothEditMutationCompleteObservable } from 'admin-data/booth/BoothEdit/redux/epics/queries/utils';
import { createExecutingTask } from 'utils/xtra-executing-tasks/executingTask';
import { boothEditExecutingTasksTagCreator } from 'admin-data/booth/BoothEdit/redux/boothEditExecutingTasks';
import { fetchAllPage } from 'utils/requestsUtils';
import { Booth } from 'models';
import { concat } from 'rxjs';
import cmsSelectors from 'redux/cmsSelectors';

const queryEventDesignsListEpic: Epic = (action$, state$) => action$.pipe(
  filter(boothEditActions.queries.queryEventDesignsList.match),
  mergeMap(() => {
    const sdk = cmsSelectors.selectAuthorizedSDKObservables(state$.value);
    const boothId = boothEditSelectors.selectBoothId(state$.value);
    const locale = boothEditSelectors.selectLocale(state$.value);
    const originalBoothFactory = () => boothEditSelectors.selectBooth(state$.value);

    const taskFactory = () => createExecutingTask({ tags: [boothEditExecutingTasksTagCreator.queries.queryEventDesignsList()] });

    const requests = fetchAllPage(
      (after) => sdk.boothEditGetBoothDesignsList({ boothId, locales: [locale], after }),
      (resp) => (resp.node as Booth).event.boothDesigns.pageInfo,
    ).pipe(
      map(mapToSimpleMergeBoothAction(originalBoothFactory)),
    );

    return concat(
      boothEditMutationCompleteObservable(action$, state$),
      requests,
    ).pipe(boothEditActions.executingTasks.wrapWithExecutingTaskAction(taskFactory));
  }),
);

export default queryEventDesignsListEpic;
